import {BooleanField, Datagrid, ListProps, TextField} from "react-admin";
import {CustomList} from "../../components/CustomList";
import {initField} from "../../shared/utils";
import {useOptionsResource} from "../../shared/hooks/useOptionsResource";
import {IdentifierField} from "../../components/IdentifierField";


export const WorkPermitTypeList = (props: ListProps) => {
    const {data: options} = useOptionsResource("GET");

    return options ? (
        <CustomList
            {...props}
        >
            <Datagrid>
                <IdentifierField {...initField("id", options)}/>
                <TextField {...initField("code", options)}/>
                <TextField {...initField("name", options)}/>
                <TextField {...initField("unit", options)}/>
                <BooleanField {...initField("file_required", options)}/>
            </Datagrid>
        </CustomList>
    ) : null;
}